import { Outlet, useLocation, useNavigate } from 'react-router'
import { ArrowBack } from '@mui/icons-material'
import { Grid, IconButton, Typography, useTheme } from '@mui/material'

import meshifyLogo from '../../images/meshify-logo2.svg'
import { HspPlusProvider } from '../../providers/hsp-plus-provider'
import useIsMobile from '../../utils/hooks/useIsMobile'
import useScrollToTop from '../../utils/hooks/useScrollToTop'
import ErrorBoundary from '../error-boundary'

import useStyles from './index.styles'

const LOGO_HEADER_PATH = '/registration'

const HSPRouteContent = () => {
  const theme = useTheme()
  const isMobile = useIsMobile()
  const classes = useStyles
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const hasGradientBackground = pathname.endsWith('/app-download')
  const hasLogo = pathname.endsWith(LOGO_HEADER_PATH)
  useScrollToTop()

  return (
    <ErrorBoundary>
      <Grid container={true} sx={classes.background(theme, isMobile)}>
        <Grid container={true} component="section" sx={classes.card(theme, isMobile, hasGradientBackground)}>
          {hasLogo ? (
            <Grid container={true} component="header" sx={classes.header}>
              <img src={meshifyLogo} alt="Meshify" width={110} height={60} />
            </Grid>
          ) : (
            <Grid container={true} component="header" sx={classes.backHeader}>
              <IconButton color="inherit" aria-label="Go back" onClick={() => navigate(-1)}>
                <ArrowBack />
              </IconButton>
              <Typography variant="subtitle1">Registration</Typography>
            </Grid>
          )}
          <Grid container={true} component="main" sx={classes.content}>
            <Outlet />
          </Grid>
        </Grid>
      </Grid>
    </ErrorBoundary>
  )
}

const HSPRouteWrapper = () => {
  return (
    <HspPlusProvider>
      <HSPRouteContent />
    </HspPlusProvider>
  )
}

export default HSPRouteWrapper
